import * as React from "react";

const Close: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M19.7168 4.40053C20.1518 4.86911 20.1317 5.59964 19.6717 6.04363L13.5 12.0001L19.6936 18.1989C20.1337 18.6393 20.1191 19.3574 19.6616 19.7796V19.7796C19.2265 20.1811 18.5512 20.1647 18.1361 19.7424L12 13.5001L5.86386 19.7424C5.44882 20.1647 4.77352 20.1811 4.33841 19.7796V19.7796C3.88085 19.3574 3.86629 18.6393 4.30635 18.1989L10.5 12.0001L4.32832 6.04363C3.86827 5.59964 3.84822 4.86911 4.28321 4.40053V4.40053C4.73856 3.91002 5.51127 3.89898 5.98045 4.37629L12 10.5001L18.0195 4.37629C18.4887 3.89898 19.2614 3.91002 19.7168 4.40053V4.40053Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(Close);
